import React from 'react'

function LeftIcon({ size = 26, color = "currentColor", ...rest }) {
    return (
        <svg {...rest} width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.32267 6.95632C9.13098 5.56428 11.7502 6.85338 11.7501 9.13544V11.2501L22.0001 11.2501C22.4144 11.2501 22.7501 11.5859 22.7501 12.0001C22.7501 12.4143 22.4144 12.7501 22.0001 12.7501L11.7502 12.7501V14.8647C11.7502 17.1468 9.13098 18.4359 7.32267 17.0438L3.60139 14.1792C2.17136 13.0784 2.17136 10.9218 3.60139 9.82096L7.32267 6.95632ZM8.23766 8.14493C9.05962 7.51218 10.2502 8.09814 10.2502 9.13544L10.2501 12.0001L10.2502 14.8647C10.2502 15.902 9.05962 16.488 8.23766 15.8552L4.51638 12.9906C3.86637 12.4902 3.86637 11.5099 4.51638 11.0096L8.23766 8.14493Z" fill={color} />
        </svg>

    )
}

export default LeftIcon